module.exports = __webpack_public_path__ + "static/media/bob-logomark-green-header.aac00c50.png";